import {
	ROUND_CREATE,
	ROUND_ADD_STACK,
	ROUND_REMOVE_STACK,
	ROUND_SET
} from '../actionTypes';

const initialState = {
	byId: {},
	allIds: [],
	currentRoundId: ''
};

export default function(state = initialState, action) {
	if (action.payload)
		var { index, stacks, roundId, currentRoundId, stackId } = action.payload;

	switch (action.type) {
		case ROUND_CREATE:
			return {
				byId: {
					...state.byId,
					[roundId]: {
						roundId,
						index,
						stacks
					}
				},
				allIds: [...state.allIds, roundId]
			};
		case ROUND_SET:
			return {
				...state,
				currentRoundId
			}
		case ROUND_ADD_STACK:
			return {
				...state,
				byId: {
					...state.byId,
					[roundId]: {
						...state.byId[roundId],
						stacks: [...state.byId[roundId].stacks, stackId]
					}
				}
			};
		case ROUND_REMOVE_STACK:
			const newStacks = state.byId[roundId].stacks.filter(existingStackId => {
				return existingStackId !== stackId;
			});
			return {
				...state,
				byId: {
					...state.byId,
					[roundId]: {
						...state.byId[roundId],
						stacks: [...newStacks]
					}
				}
			};
		default:
			return state;
	}
}
